import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

const ContactFooter = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" className="pad-2xl">
      <div className="container">
        <h2 className="heading-2 text-center mb-4">{t.contact.title}</h2>
        <p className="body-medium text-center mb-12" style={{ color: 'var(--text-secondary)' }}>
          {t.contact.subtitle}
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <Phone className="w-8 h-8 mx-auto mb-3" style={{ color: 'var(--accent-text)' }} />
            <h3 className="font-semibold mb-2 flex items-center justify-center gap-2" style={{ color: 'var(--text-primary)' }}>
              {t.contact.phone}
            </h3>
            <p className="body-small flex items-center justify-center gap-2">
              <img src="https://flagcdn.com/w40/gr.png" alt="Greece" className="w-5 h-auto" />
              <a href="tel:+306994411844" className="hover:underline">+30 699 441 1844</a>
            </p>
            <p className="body-small flex items-center justify-center gap-2">
              <img src="https://flagcdn.com/w40/gb.png" alt="UK" className="w-5 h-auto" />
              <a href="tel:+306906604673" className="hover:underline">+30 690 660 4673</a>
            </p>
          </div>
          
          <div className="text-center">
            <Mail className="w-8 h-8 mx-auto mb-3" style={{ color: 'var(--accent-text)' }} />
            <h3 className="font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
              {t.contact.email}
            </h3>
            <p className="body-small">
              <a href="mailto:greecebay2@gmail.com" className="hover:underline">
                greecebay2@gmail.com
              </a>
            </p>
          </div>
          
          <div className="text-center">
            <MapPin className="w-8 h-8 mx-auto mb-3" style={{ color: 'var(--accent-text)' }} />
            <h3 className="font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
              {t.contact.areas}
            </h3>
            <p className="body-small">{t.contact.areasText}</p>
          </div>
        </div>

        <div className="text-center mb-8">
          <h3 className="font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>
            {t.contact.social}
          </h3>
          <div className="flex gap-4 justify-center">
            <a 
              href="https://www.instagram.com/nea_clean/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full hover:bg-[var(--bg-section)] transition-colors"
              style={{ color: 'var(--accent-text)' }}
            >
              <Instagram className="w-6 h-6" />
              <span className="font-medium">Instagram</span>
            </a>
            <a 
              href="https://www.facebook.com/profile.php?id=61584596424715&locale=bg_BG" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full hover:bg-[var(--bg-section)] transition-colors"
              style={{ color: 'var(--accent-text)' }}
            >
              <Facebook className="w-6 h-6" />
              <span className="font-medium">Facebook</span>
            </a>
          </div>
        </div>

        <div className="text-center pt-8 border-t" style={{ borderColor: 'var(--border-light)' }}>
          <p className="caption">{t.contact.copyright}</p>
        </div>
      </div>
    </section>
  );
};

export default ContactFooter;
